import { Square2StackIcon } from "@heroicons/react/24/outline";
import { useQuery } from "@tanstack/react-query";
import { useCopyToClipboard, useDocumentTitle } from "@uidotdev/usehooks";
import StyledLink from "../../components/Link";
import { SUPPORT_EMAIL } from "../../constants/globals";
import { useUserGuideApi } from "../../hooks";
import { Card } from "../../ui/Card";
import { ROUTES } from "..";

export const SupportPage = () => {
    useDocumentTitle("Help & Support - AERSHED");

    const [, copyToClipBoard] = useCopyToClipboard();
    const apiClient = useUserGuideApi();

    const dataProvidersQuery = useQuery({
        queryKey: ["dataProvidersWithData"],
        queryFn: async () => {
            return await apiClient.userGuideRetrieve();
        },
        refetchOnWindowFocus: false,
        staleTime: 0,
    });
    console.log(dataProvidersQuery.data);

    return (
        <div className="prose px-6 max-w-6xl mx-auto">
            <h1 className="flex pt-10 font-bold font-sans antialiased text-inherit text-xl">
                Help & Support
            </h1>

            <Card>
                <p className="text-base">
                    <a
                        className="text-base text-blue-700"
                        href={dataProvidersQuery.data?.file}
                    >
                        Download the user training guide
                    </a>{" "}
                    to learn how to use AERSHED.
                </p>
                <p className="flex items-center text-base">
                    If you need help, please e-mail us at{" "}
                    <a
                        className="text-base text-blue-700 ml-1 mr-2"
                        href={`mailto:${SUPPORT_EMAIL}`}
                    >
                        {SUPPORT_EMAIL}
                    </a>
                    <button
                        className="flex items-center text-sm justify-center"
                        onClick={() => copyToClipBoard(SUPPORT_EMAIL)}
                    >
                        <Square2StackIcon className="w-4 h-4 mr-1" />
                        Copy
                    </button>
                </p>

                <hr className="my-4" />

                <p className="text-base">
                    Useful links:
                    <StyledLink to={ROUTES.TERMS_OF_SERVICE}>
                        Terms of Service
                    </StyledLink>
                    <StyledLink to={ROUTES.PRIVACY_POLICY}>
                        Privacy Policy
                    </StyledLink>
                </p>
            </Card>
        </div>
    );
};
